export default "__VITE_ASSET__fLh5OJ2I__"